export const normalizeList = (data) => {
  if (Array.isArray(data)) return data;
  if (data && Array.isArray(data.results)) return data.results;
  return [];
};

export const fkId = (value) => {
  if (!value) return "";
  if (typeof value === "string") return value;
  if (typeof value === "number") return String(value);

  if (typeof value === "object") {
    return (
      value.hospital_id ||
      value.organization_id ||
      value.organization ||
      value.ward_id ||
      value.ward ||
      value.room_id ||
      value.room ||
      value.department_id ||
      value.user_id ||
      value.id ||
      ""
    );
  }
  return String(value);
};

export const sameId = (a, b) => String(a || "") === String(b || "");